import React from 'react';
import { useTranslation } from 'react-i18next';

import warningIcon from '../../../assets/petDemos/warning.svg';
import subtractIcon from '../../../assets/petDemos/subract-circle.svg';
import {
  ReactComponent as CheckIcon,
} from '../../../assets/check-onyx.svg';

import styles from './CoveragePeriodStatus.module.css';

const CoveragePeriodStatus = ({
  isCoveragePeriodCompleted = false,
  noPendingAction = false,
}) => {
  const { t } = useTranslation('petDemos');

  if (noPendingAction) {
    return (
      <div className={styles.noPendingActionStatus}>
        <img alt="" src={subtractIcon} />

        <span>{t('policyInformation.noPendingAction')}</span>
      </div>
    );
  }

  return (
    <div
      className={styles.policyCoverageStatus}
      data-completed={isCoveragePeriodCompleted}
    >
      {isCoveragePeriodCompleted ? <CheckIcon className={styles.check} />
        : <img alt="" src={warningIcon} />}

      <span>{isCoveragePeriodCompleted ? t('policyInformation.completed')
        : t('policyInformation.pendingInformation')}
      </span>
    </div>
  );
};

export { CoveragePeriodStatus };
